import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0a9af71b"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "text-start ps-0"
}
const _hoisted_2 = { class: "nav-item d-flex" }
const _hoisted_3 = { class: "d-flex" }
const _hoisted_4 = { class: "col-link ps-1" }
const _hoisted_5 = {
  key: 0,
  class: "mt-3",
  style: {"margin-bottom":"-0.5rem"}
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "position-absolute nav-guide-line py-1" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "vr" })
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BIconCheckLg = _resolveComponent("BIconCheckLg")!
  const _component_VerticalNavSubList = _resolveComponent("VerticalNavSubList")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["v-step-nav position-relative", (_ctx.screenWidth === _ctx.ScreenWidth.Small)? '': (_ctx.screenWidth === _ctx.ScreenWidth.Medium)? 'ms-3': 'ms-5'])
  }, [
    (_ctx.navItems.length > 0)
      ? (_openBlock(), _createElementBlock("ul", _hoisted_1, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.navItems, (item, index) => {
            return (_openBlock(), _createElementBlock("li", {
              key: index,
              class: "mb-3"
            }, [
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("div", _hoisted_3, [
                  _createElementVNode("span", {
                    class: _normalizeClass(["circle", {'bg-light-gray': (!item.isChecked && !_ctx.isActive(_ctx.activeItem, item)) }])
                  }, [
                    (item.isChecked)
                      ? (_openBlock(), _createBlock(_component_BIconCheckLg, {
                          key: 0,
                          class: "circle-icon"
                        }))
                      : (_openBlock(), _createElementBlock("span", {
                          key: 1,
                          class: _normalizeClass(["circle-font", {'unchecked-text': !item.isChecked, 'text-white': _ctx.isActive(_ctx.activeItem, item)}])
                        }, _toDisplayString(index + 1), 3))
                  ], 2)
                ]),
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("span", {
                    class: _normalizeClass(["item-content item-placeholder-gray", { active: _ctx.isActive(_ctx.activeItem, item) }])
                  }, _toDisplayString(item.text), 3),
                  (
                _ctx.isActive(_ctx.activeItem, item) &&
                  item.subItems &&
                  item.subItems.length > 0
              )
                    ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                        _createVNode(_component_VerticalNavSubList, {
                          items: item.subItems,
                          "active-item": _ctx.activeItem
                        }, null, 8, ["items", "active-item"])
                      ]))
                    : _createCommentVNode("", true)
                ])
              ])
            ]))
          }), 128))
        ]))
      : _createCommentVNode("", true),
    _hoisted_6
  ], 2))
}